import { render, staticRenderFns } from "./optionGoodsMngt.vue?vue&type=template&id=5a3fe155"
import script from "./optionGoodsMngt.vue?vue&type=script&lang=js"
export * from "./optionGoodsMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports